/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_CreditsInputs */

const en_admin_nav_credits = /** @type {(inputs: Admin_Nav_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const zh_admin_nav_credits = /** @type {(inputs: Admin_Nav_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Admin_Nav_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_nav_credits = /** @type {((inputs?: Admin_Nav_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_credits(inputs)
	return zh_admin_nav_credits(inputs)
});
export { admin_nav_credits as "admin.nav.credits" }